import { render, staticRenderFns } from "./BookingDocumentActions.vue?vue&type=template&id=f4d25456&"
import script from "./BookingDocumentActions.vue?vue&type=script&lang=js&"
export * from "./BookingDocumentActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports